import { useCallback, useEffect, useState } from 'react';

import { isAdpReferralSubmitted, setAdpReferralSubmitted } from '#client/pages/ProductLanding/utils/adpReferralStorage';

export function useAdpReferralCtaState({ isAdpProduct, businessEntityUuid, productId }) {
  const [adpReferralSubmitted, setAdpReferralSubmittedState] = useState(() =>
    isAdpProduct ? isAdpReferralSubmitted(businessEntityUuid, productId) : false,
  );

  useEffect(() => {
    if (!isAdpProduct) {
      setAdpReferralSubmittedState(false);
      return;
    }

    setAdpReferralSubmittedState(isAdpReferralSubmitted(businessEntityUuid, productId));
  }, [businessEntityUuid, isAdpProduct, productId]);

  const markAdpReferralSubmitted = useCallback(() => {
    if (!isAdpProduct || !businessEntityUuid) {
      return;
    }

    setAdpReferralSubmitted(businessEntityUuid, productId);
    setAdpReferralSubmittedState(true);
  }, [businessEntityUuid, isAdpProduct, productId]);

  return {
    adpReferralSubmitted,
    markAdpReferralSubmitted,
  };
}
